import { genericFetch } from "./common-service"
import { oauthBaseUrl, clientId, clientSecret } from "./config"
import { Token } from "../../model"

const baseTokenUrl = `${oauthBaseUrl}/token`

export function findToken(username, password): Promise<Token> {
	const body = JSON.stringify({
		grant_type: 'password',
		client_id: clientId,
		client_secret: clientSecret,
		username: username,
		password: password
	})

	const init: RequestInit = {
		body,
		headers: { "Content-Type": "application/json" },
		method: "POST"
	}

	return genericFetch<Token>(baseTokenUrl, init)
}



// WEBPACK FOOTER //
// ./src/service/sfp/tokens-service.ts